
import { Component, Vue, Prop } from 'vue-property-decorator';
import tLoading from '../t-Loading/index.vue';

@Component({
  components: {
    tLoading,
  },
})
export default class TButton extends Vue {
  @Prop({
    type: String,
    default: '#4f93fe',
  }) color!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  @Prop(String) text?: string;

  @Prop(Number) width?: number;
}
